
export type Translation = {
    name: string;
    language: string;
}

export type Type = {
    value: string;
    translations: Translation[];
}

export type TypesForCategory = {
    category: string;
    values: Type[];
}


export const types: TypesForCategory[] = [
    {
        category: "makeup", values: [
            { value: 'concealer', translations: [{ name: "korektor", language: "pl" }, { name: "concealer", language: "en" }] },
            { value: 'foundation', translations: [{ name: "podkład", language: "pl" }, { name: "foundation", language: "en" }] },
            { value: 'powder', translations: [{ name: "puder", language: "pl" }, { name: "powder", language: "en" }] },
            { value: 'eyeshadow', translations: [{ name: "cień do powiek", language: "pl" }, { name: "eyeshadow", language: "en" }] },
            { value: 'lipstick', translations: [{ name: "szminka", language: "pl" }, { name: "lipstick", language: "en" }] },
            { value: 'lipgloss', translations: [{ name: "błyszczyk", language: "pl" }, { name: "lipgloss", language: "en" }] },
            { value: 'blusher', translations: [{ name: "róż", language: "pl" }, { name: "blusher", language: "en" }] },
            { value: 'highlighter', translations: [{ name: "rozświetlacz", language: "pl" }, { name: "highlighter", language: "en" }] },
            { value: 'primer', translations: [{ name: "baza pod makijaż", language: "pl" }, { name: "base primer", language: "en" }] },
            { value: 'mascara', translations: [{ name: "tusz do rzęs", language: "pl" }, { name: "mascara", language: "en" }] },
            { value: 'eyeliner', translations: [{ name: "eyeliner/kredka", language: "pl" }, { name: "eyeliner", language: "en" }] },
            { value: 'bronzer', translations: [{ name: "bronzer", language: "pl" }, { name: "bronzer", language: "en" }] },
            { value: 'lipliner', translations: [{ name: "konturówka do ust", language: "pl" }, { name: "lip liner", language: "en" }] },
            { value: 'palette', translations: [{ name: "paleta do makijażu", language: "pl" }, { name: "makeup palette", language: "en" }] }
        ]
    },
    {
        category: "skincare", values: [
            { value: 'facecream', translations: [{ name: "krem do twarzy", language: "pl" }, { name: "face cream", language: "en" }] },
            { value: 'serum', translations: [{ name: "serum", language: "pl" }, { name: "serum", language: "en" }] },
            { value: 'eyecream', translations: [{ name: "krem pod oczy", language: "pl" }, { name: "eye cream", language: "en" }] },
            { value: 'mask', translations: [{ name: "maseczka", language: "pl" }, { name: "mask", language: "en" }] },
            { value: 'lipbalm', translations: [{ name: "balsam do ust", language: "pl" }, { name: "lip balm", language: "en" }] },
            { value: 'eyeserum', translations: [{ name: "odżywka do rzęs lub brwi", language: "pl" }, { name: "eye serum", language: "en" }] },
            { value: 'cleanser', translations: [{ name: "demakijaż", language: "pl" }, { name: "cleanser", language: "en" }] },
            { value: 'tonic', translations: [{ name: "tonik", language: "pl" }, { name: "face tonic", language: "en" }] },
            { value: 'peeling', translations: [{ name: "peeling", language: "pl" }, { name: "peeling", language: "en" }] },
            { value: 'SPF', translations: [{ name: "kremy SPF", language: "pl" }, { name: "SPF cream", language: "en" }] },
        ]
    },
    {
        category: "bodycare", values: [
            { value: 'lotion', translations: [{ name: "balsam", language: "pl" }, { name: "body lotion", language: "en" }] },
            { value: 'oil', translations: [{ name: "olejek", language: "pl" }, { name: "skin oil", language: "en" }] },
            { value: 'peeling', translations: [{ name: "peeling", language: "pl" }, { name: "peeling", language: "en" }] },
            { value: 'soap', translations: [{ name: "mydło", language: "pl" }, { name: "soap", language: "en" }] },
            { value: 'bathsalt', translations: [{ name: "sól do kąpieli", language: "pl" }, { name: "bath salt", language: "en" }] },
            { value: 'showergel', translations: [{ name: "żel pod prysznic", language: "pl" }, { name: "shower gel", language: "en" }] },
            { value: 'handcream', translations: [{ name: "krem do rąk", language: "pl" }, { name: "hand cream", language: "en" }] },
            { value: 'feetcream', translations: [{ name: "krem do stóp", language: "pl" }, { name: "feetcream", language: "en" }] },
            { value: 'deodorant', translations: [{ name: "dezodorant", language: "pl" }, { name: "deodorant", language: "en" }] },
            { value: 'SPF', translations: [{ name: "kremy SPF", language: "pl" }, { name: "SPF cream", language: "en" }] },
            { value: 'teeth', translations: [{ name: "produkt do zębów", language: "pl" }, { name: "teeth product", language: "en" }] },
            { value: 'depilation', translations: [{ name: "depilacja", language: "pl" }, { name: "depilation", language: "en" }] },
            { value: 'intimate', translations: [{ name: "higiena intymna", language: "pl" }, { name: "intimate hygiene", language: "en" }] },
        ]
    },
    {
        category: "hair", values: [
            { value: 'shampoo', translations: [{ name: "szampon", language: "pl" }, { name: "shampoo", language: "en" }] },
            { value: 'conditioner', translations: [{ name: "odżywka", language: "pl" }, { name: "conditioner", language: "en" }] },
            { value: 'mask', translations: [{ name: "maska", language: "pl" }, { name: "mask", language: "en" }] },
            { value: 'lotion', translations: [{ name: "wcierka", language: "pl" }, { name: "lotion", language: "en" }] },
            { value: 'oil', translations: [{ name: "olejek", language: "pl" }, { name: "oil", language: "en" }] },
            { value: 'serum', translations: [{ name: "serum", language: "pl" }, { name: "serum", language: "en" }] },
            { value: 'colorization', translations: [{ name: "koloryzacja", language: "pl" }, { name: "colorization", language: "en" }] },
            { value: 'stylization', translations: [{ name: "stylizacja", language: "pl" }, { name: "stylization", language: "en" }] },
        ]
    },
    {
        category: "nails", values: [
            { value: 'varnish', translations: [{ name: "lakier", language: "pl" }, { name: "varnish", language: "en" }] },
            { value: 'polishremover', translations: [{ name: "zmywacz do paznokci", language: "pl" }, { name: "polish remover", language: "en" }] },
            { value: 'accessories', translations: [{ name: "akcesoria", language: "pl" }, { name: "accessories", language: "en" }] },
            { value: 'serum', translations: [{ name: "serum", language: "pl" }, { name: "serum", language: "en" }] },
        ]
    },
    {
        category: "accessories", values: [
            { value: 'brushes', translations: [{ name: "pędzle", language: "pl" }, { name: "brushes", language: "en" }] },
            { value: 'razors', translations: [{ name: "maszynka do golenia", language: "pl" }, { name: "razors", language: "en" }] },
            { value: 'teethbrush', translations: [{ name: "szczoteczka do zębów", language: "pl" }, { name: "teeth brush", language: "en" }] },
            { value: 'beautyblender', translations: [{ name: "beauty blender", language: "pl" }, { name: "beauty blender", language: "en" }] },
            { value: 'tweezers', translations: [{ name: "pęseta", language: "pl" }, { name: "tweezers", language: "en" }] },
            { value: 'scissors', translations: [{ name: "nożyczki", language: "pl" }, { name: "scissors", language: "en" }] },
            { value: 'candle', translations: [{ name: "świeczka", language: "pl" }, { name: "candle", language: "en" }] }
        ]
    },
    {
        category: "perfume", values: [
            { value: 'women', translations: [{ name: "damskie", language: "pl" }, { name: "women", language: "en" }] },
            { value: 'men', translations: [{ name: "męskie", language: "pl" }, { name: "men", language: "en" }] },
            { value: 'unisex', translations: [{ name: "unisex", language: "pl" }, { name: "unisex", language: "en" }] },
        ]
    }
];

